//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const mpc = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getMpc(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/mpc/get-mpc?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getMpcDetail(id) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/get-mpc/${id}`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/mpc/search?query=${encodeURIComponent(query)}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getSalesCategory() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/mpc/get-sales-category`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getOrg() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/get-org`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function update(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/update`, obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  async function mpcFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/mpc/mpc-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function mpcExport(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/export`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getMpcMajor() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/get-mpc-major`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function getMpcMinorByMajor(major_id) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/get-mpc-minor/${major_id}`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }

  async function getMpcByMajorAndMinor(major_id,minor_id) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/get-mpc-major-and-minor/${major_id}/${minor_id}`, obj);
      return handleResponse(res);
    } 
    catch (err) {
      handleError(err);
    }
  }
  
  async function mpcMassupdate(values) {
    try {
      const obj = {
        method: "POST",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
        body: JSON.stringify(values),
      };
      let res = await fetch(`${config.host}/cdr-panel/mpc/update/MassUpdate`, obj);
      let body = await res.json();
      return body;
    } catch (err) {}
  }

  return {
    getMpc,
    getMpcDetail,
    search,
    getSalesCategory,
    getOrg,
    mpcFilter,
    update,
    mpcMassupdate,
    mpcExport,
    getMpcMajor,
    getMpcMinorByMajor,
    getMpcByMajorAndMinor
  };
};

export default mpc;
